import { useEffect, useState } from "react";
import React from "react";
import { Row, Col, Form, Button, Card, Container } from "react-bootstrap";
import { ImProfile } from "react-icons/im";

export default function StudentPromotion() {
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? "270px" : "0px"
  );

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? "270px" : "0px");
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ marginLeft }}>
      <div
        className="container-fluid p-0"
        style={{
          marginTop: window.innerWidth < 768 ? "55px" : "-11px",
        }}
      >
        <div>
          <h1 className="text-center p-4 bg-secondary rounded shadow text-white mt-md-0 mt-5">
            Student Promotion
          </h1>
        </div>
      </div>

      <div className="mt-5">
        <Container>
          <Row className="mb-3 align-items-center">
            {/* Title - Left on Desktop, Center on Mobile */}
            <Col md={6} xs={12} className="text-md-start text-center">
              <h4 className="text-primary fw-bold mb-0">Student Promotion</h4>
            </Col>

            {/* Session Info - Right on Desktop, Center on Mobile */}
            <Col md={6} xs={12} className="text-md-end text-center text-muted">
              <span className="d-inline-flex align-items-center gap-2">
                <ImProfile size={20} className="text-primary" />
                <span>
                  Current Session: <strong>2024-2025</strong>
                </span>
              </span>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="mt-5">
        <Card className="p-4 mt-4 shadow-sm border-0">
          <div className="d-flex flex-wrap gap-3">
            <div className="flex-grow-1">
              <Form.Group className="text-start">
                <Form.Label className="fw-bold text-start">
                  Select Course
                </Form.Label>
                <Form.Select>
                  <option>Select Course</option>
                  <option value="1">Math</option>
                  <option value="2">Science</option>
                </Form.Select>
              </Form.Group>
            </div>

            <div className="flex-grow-1">
              <Form.Group className="text-start">
                <Form.Label className="fw-bold text-start">
                  Select Class
                </Form.Label>
                <Form.Select>
                  <option>Select Class</option>
                  <option value="1">6th</option>
                  <option value="2">7th</option>
                </Form.Select>
              </Form.Group>
            </div>

            <div className="flex-grow-1">
              <Form.Group className="text-start">
                <Form.Label className="fw-bold text-start">
                  Student List
                </Form.Label>
                <Form.Select>
                  <option>Student List</option>
                  <option value="1">Avni</option>
                  <option value="2">Aditya</option>
                  <option value="1">Avni</option>
                  <option value="2">Aditya</option>
                </Form.Select>
              </Form.Group>
            </div>
          </div>
        </Card>
      </div>

      <div className="shadow-sm p-4 rounded mt-2">
        <Container>
          <Row className="g-4 text-start mt-4">
            {/* From Course & From Class - Side by Side on Mobile */}
            <Col xs={6} md={2}>
              <Form.Group>
                <Form.Label className="fw-semibold">From Course</Form.Label>
                <Form.Select>
                  <option>Select Course</option>
                  <option>Basic</option>
                  <option>Python</option>
                  <option>Java</option>
                  <option>Digital Marketing</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col xs={6} md={2}>
              <Form.Group>
                <Form.Label className="fw-semibold">From Class</Form.Label>
                <Form.Select>
                  <option>Select Class</option>
                  <option>B</option>
                  <option>C</option>
                  <option>D</option>
                  <option>E</option>
                </Form.Select>
              </Form.Group>
            </Col>

            {/* To Course & To Class - Below in Mobile, Side by Side in Desktop */}
            <Col xs={6} md={2}>
              <Form.Group>
                <Form.Label className="fw-semibold">To Course</Form.Label>
                <Form.Select>
                  <option>Select Course</option>
                  <option>Basic</option>
                  <option>Python</option>
                  <option>Java</option>
                  <option>Digital Marketing</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col xs={6} md={2}>
              <Form.Group>
                <Form.Label className="fw-semibold">To Class</Form.Label>
                <Form.Select>
                  <option>Select Class</option>
                  <option>B</option>
                  <option>C</option>
                  <option>D</option>
                  <option>E</option>
                </Form.Select>
              </Form.Group>
            </Col>

            {/* Promote Button - Full Width on Mobile, Right-Aligned on Desktop */}
            <Col
              xs={12}
              md={4}
              className="d-flex justify-content-center justify-content-md-end"
            >
              <Button variant="primary" className="w-100 fw-bold">
                Promote
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}
